import { render, staticRenderFns } from "./Football.vue?vue&type=template&id=7cb1bd98&scoped=true&"
import script from "./Football.vue?vue&type=script&lang=js&"
export * from "./Football.vue?vue&type=script&lang=js&"
import style0 from "./Football.vue?vue&type=style&index=0&id=7cb1bd98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb1bd98",
  null
  
)

export default component.exports